import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const base_url = process.env.REACT_APP_API_URL;

export default function Withdraw() {
const token = localStorage.getItem("token");
  const [method, setMethod] = useState("bank");
  const [amount, setAmount] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [needBet, setNeedBet] = useState(0);
  const [userWallet, setUserWallet] = useState(0);
  const withdrawableAmount = Math.max(userWallet - needBet, 0);

  const [details, setDetails] = useState({
    bankName: "",
    holder: "",
    account: "",
    ifsc: "",
    upi: "",
    upi_qr: "",
    usdt: "",
  });

  useEffect(() => {
    fetchWithdrawDetails();
    fetchWithdrawInfo();
  }, []);

  const fetchWithdrawInfo = async () => {
    try {
      const res = await axios.get(`${base_url}/api/webapi/userInfo`, {
        headers: { Authorization: token },
      });

      if (res.data.status) {
        console.log(res.data);

        setNeedBet(res.data.data.remaining_money || 0);
        setUserWallet(res.data.data.money || 0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchWithdrawDetails = async () => {
    try {
      const res = await axios.get(`${base_url}/api/user/withdraw-details`, {
        headers: { Authorization: token },
      });

      if (res.data.success) {
        const d = res.data.data;

        setDetails({
          bankName: d.bank_name || "",
          holder: d.holder_name || "",
          account: d.account_no || "",
          ifsc: d.ifsc || "",
          upi: d.upi_id || "",
          upi_qr: d.upi_qr || "",
          usdt: d.usdt_address || "",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const saveDetails = async () => {
    try {
      const data = new FormData();

      data.append("method", method);
      data.append("bank_name", details.bankName);
      data.append("holder_name", details.holder);
      data.append("account_no", details.account);
      data.append("ifsc", details.ifsc);
      data.append("upi_id", details.upi);
      data.append("usdt_address", details.usdt);

      if (details.upi_qr instanceof File) {
        data.append("upi_qr", details.upi_qr);
      }

      await axios.post(`${base_url}/api/user/save-withdraw-details`, data, {
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Details saved");
      setEditMode(false);
      fetchWithdrawDetails();
    } catch (err) {
      toast.error("Failed to save details");
    }
  };

  const submitWithdraw = async () => {
    const withdrawAmount = Number(amount);

    if (!withdrawAmount) {
      toast.error("Enter withdraw amount");
      return;
    }

    if (withdrawAmount < 110) {
      toast.error("Minimum withdraw is ₹110");
      return;
    }

    if (withdrawAmount > 100000) {
      toast.error("Maximum withdraw is ₹100000");
      return;
    }

    if (withdrawAmount > withdrawableAmount) {
      toast.error(`Maximum withdrawable amount is ₹${withdrawableAmount}`);
      return;
    }

    if (
      (method === "bank" && !hasBank) ||
      (method === "upi" && !hasUpi) ||
      (method === "usdt" && !hasUsdt)
    ) {
      toast.error("Please add withdrawal details first");
      setEditMode(true);
      return;
    }

    try {
      const res = await axios.post(
        `${base_url}/api/create-withdraw`,
        {
          amount: withdrawAmount,
          method,
        },
        {
          headers: { Authorization: token },
        },
      );

      toast.success(res.data.message);

      setAmount("");
      fetchWithdrawInfo();

      // trigger navbar update
      window.dispatchEvent(new Event("walletUpdated"));
      
    } catch (err) {
      toast.error("Withdraw failed");
    }
  };

  const hasBank = details.account;
  const hasUpi = details.upi;
  const hasUsdt = details.usdt;

  const quickAmounts = [200, 500, 1000, 2000, 5000, 10000];

  return (
    <div className="withdrawPageMain">
      <div className="withdrawPage">
        {/* METHODS */}

        <div className="withdrawMethods">
          <div
            className={`methodItem ${method === "bank" ? "active" : ""}`}
            onClick={() => {
              setMethod("bank");
              setEditMode(false);
            }}
          >
            Bank
          </div>

          <div
            className={`methodItem ${method === "upi" ? "active" : ""}`}
            onClick={() => {
              setMethod("upi");
              setEditMode(false);
            }}
          >
            UPI
          </div>

          <div
            className={`methodItem ${method === "usdt" ? "active" : ""}`}
            onClick={() => {
              setMethod("usdt");
              setEditMode(false);
            }}
          >
            USDT
          </div>
        </div>

        {/* BANK DETAILS */}

        {method === "bank" && hasBank && !editMode && (
          <div className="detailsCard">
            <p>
              <b>Bank:</b> {details.bankName}
            </p>
            <p>
              <b>Recipient:</b> {details.holder}
            </p>
            <p>
              <b>Account:</b> {details.account}
            </p>
            <p>
              <b>IFSC:</b> {details.ifsc}
            </p>

            <div className="changeBtn" onClick={() => setEditMode(true)}>
              Change Bank Information
            </div>
          </div>
        )}

        {method === "bank" && !hasBank && !editMode && (
          <div className="upiBox" onClick={() => setEditMode(true)}>
            <p>Add Bank Details</p>
          </div>
        )}

        {/* UPI DETAILS */}

        {method === "upi" && hasUpi && !editMode && (
          <div className="detailsCard">
            {details.upi_qr && (
              <img
                src={`${base_url}/uploads/${details.upi_qr}`}
                alt="QR"
                className="qrImage"
              />
            )}

            <p>
              <b>UPI ID:</b> {details.upi}
            </p>

            <div className="changeBtn" onClick={() => setEditMode(true)}>
              Change UPI
            </div>
          </div>
        )}

        {method === "upi" && !hasUpi && !editMode && (
          <div className="upiBox" onClick={() => setEditMode(true)}>
            <p>Add UPI Details</p>
          </div>
        )}

        {/* USDT */}

        {method === "usdt" && hasUsdt && !editMode && (
          <div className="detailsCard">
            <p>
              <b>USDT Address:</b> {details.usdt}
            </p>

            <div className="changeBtn" onClick={() => setEditMode(true)}>
              Change Address
            </div>
          </div>
        )}

        {method === "usdt" && !hasUsdt && !editMode && (
          <div className="upiBox" onClick={() => setEditMode(true)}>
            <p>Add USDT Address</p>
          </div>
        )}

        {/* EDIT FORM */}

        {editMode && (
          <div className="withdrawForm">
            {method === "bank" && (
              <>
                <input
                  placeholder="Bank Name"
                  value={details.bankName}
                  onChange={(e) =>
                    setDetails({ ...details, bankName: e.target.value })
                  }
                />

                <input
                  placeholder="Account Holder"
                  value={details.holder}
                  onChange={(e) =>
                    setDetails({ ...details, holder: e.target.value })
                  }
                />

                <input
                  placeholder="Account Number"
                  value={details.account}
                  onChange={(e) =>
                    setDetails({ ...details, account: e.target.value })
                  }
                />

                <input
                  placeholder="IFSC Code"
                  value={details.ifsc}
                  onChange={(e) =>
                    setDetails({ ...details, ifsc: e.target.value })
                  }
                />
              </>
            )}

            {method === "upi" && (
              <>
                <input
                  placeholder="UPI ID"
                  value={details.upi}
                  onChange={(e) =>
                    setDetails({ ...details, upi: e.target.value })
                  }
                />

                <input
                  type="file"
                  onChange={(e) =>
                    setDetails({ ...details, upi_qr: e.target.files[0] })
                  }
                />
              </>
            )}

            {method === "usdt" && (
              <input
                placeholder="USDT Address"
                value={details.usdt}
                onChange={(e) =>
                  setDetails({ ...details, usdt: e.target.value })
                }
              />
            )}

            <button className="saveBtn" onClick={saveDetails}>
              Save
            </button>
          </div>
        )}

        <h4 className="amountTitle mt-3">Withdraw Amount</h4>

        <div className="amountGrid">
          {quickAmounts.map((a) => (
            <div
              key={a}
              className={`amountBox ${amount == a ? "active" : ""}`}
              onClick={() => setAmount(a)}
            >
              ₹ {a >= 1000 ? a / 1000 + "K" : a}
            </div>
          ))}
        </div>

        {/* AMOUNT */}

        <div className="amountInputBox">
          <span>₹</span>

          <input
            placeholder="Enter amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        {/* WITHDRAW BUTTON */}

        <button
          className="withdrawBtn"
          disabled={!amount || amount > withdrawableAmount}
          onClick={submitWithdraw}
        >
          Withdraw
        </button>

        {/* INFO */}

        <div className="withdrawInfo">
          <p>
            Need to bet{" "}
            <span className="text-danger">₹{Number(needBet).toFixed(2)}</span>{" "}
            to be able to withdraw
          </p>
          <p>Withdraw time 00:00-23:59</p>
          <p>Inday Remaining Withdrawal Times 3</p>
          <p>Withdrawal amount range ₹110 - ₹100000</p>
        </div>
      </div>
    </div>
  );
}
